import { testApi } from "@/api/testApi";

/**
 * In-app browsers (WhatsApp, Gmail, Instagram, Facebook, LinkedIn, …) and
 * Android WebViews often ignore downloads started from page script.
 */
export function isInAppBrowser(): boolean {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent || "";
  if (/FBAN|FBAV|FB_IAB|Instagram|LinkedInApp|Line\/|WhatsApp|Snapchat|GSA\/|Twitter/i.test(ua)) {
    return true;
  }
  // Android WebView marks itself with "; wv)".
  if (/Android/i.test(ua) && /; wv\)/.test(ua)) return true;
  // iOS WKWebView in third-party apps lacks the "Safari/" token.
  if (/iPhone|iPad|iPod/i.test(ua) && !/Safari\//i.test(ua)) return true;
  return false;
}

/** Helper text shown next to the Download PDF button. */
export function certificateDownloadHint(): string {
  return isInAppBrowser()
    ? "If the PDF doesn't open, use this app's menu to open the page in Chrome or Safari, then download again."
    : "Download your certificate as a PDF file.";
}

/**
 * Download the server-rendered certificate PDF.
 *
 * Replaces the old window.print() flow, which gave blank PDFs (or nothing at
 * all) on mobile browsers / in-app WebViews and when CDN images were slow.
 *
 * Navigates to a signed URL rather than saving a blob: a real URL is what
 * in-app browsers and Android's download manager can actually open. Normal
 * browsers get `Content-Disposition: attachment`, so the page stays put; in-app
 * browsers get `inline` so the system PDF viewer can take it.
 */
export async function downloadCertificatePdf(courseId: string): Promise<void> {
  const disposition = isInAppBrowser() ? "inline" : "attachment";
  const url = await testApi.certificationPdfUrl(courseId, disposition);
  window.location.assign(url);
}
